import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { BaseService } from '../shared/services/base.service';
import { Equipe } from '../models/equipe.model';
import { Page } from '../models/page.model';

@Injectable({
    providedIn: 'root'
})
export class EquipeService extends BaseService<Equipe> {

    constructor(protected injector: Injector) {
        super(`${environment.API_PRICE}/equipe`, injector);
    }

    createRetornandoId(equipe: Equipe): Observable<Equipe> {
        return this.http.post<Equipe>(`${environment.API_PRICE}/equipe`, equipe);
    }

    getByCargoId(id: number, estimativaId: number): Observable<Equipe> {
        return this.http.get<Equipe>(`${environment.API_PRICE}/equipe/getByCargoId/${id}/${estimativaId}`);
    }

    getByPropostaId(estimativaId: number): Observable<Page<Equipe>> {
        return this.http.get<Page<Equipe>>(`${environment.API_PRICE}/equipe/getByPropostaId/${estimativaId}`);
    }

    alterarPerfilProfissional(dados: { estimativaId: number, equipeId: number, profissionalId: number, cargoId: number }): Observable<any> {
        return this.http.put<any>(`${environment.API_PRICE}/equipe/AlterarPerfilProfissional`, dados);
    }
}
 